export default __webpack_public_path__ + "alberta-copy.bbac4b32cc1731221bb5.svg";